import { combine, withContext, withCallbacks } from 'react-hooks-combine'
import { withFormModel } from 'shared/hooks'
import { spec, validators } from 'utils/validation'
import { StoreContext } from 'store/context'
import { ServicesContext } from 'services/context'

import BeneficiaryPersonalFormComponent from './component'

const { string, any } = validators

export const BeneficiaryPersonalForm = combine({
  hooks: [
    withContext('appStore', StoreContext),
    withContext(
      'jurisdictionsService',
      ServicesContext,
      ({ jurisdictionsService }) => jurisdictionsService
    ),
    withFormModel((_state, { initialValues = {} }) => {
      const formattedCountry = initialValues.address?.country
        ? { id: '', name: initialValues.address.country }
        : ''
      return {
        email: {
          readonly: true,
          initialValue: initialValues.email,
          spec: spec.flow(string.isNotEmpty, any.required),
        },

        beneficiaryName: {
          initialValue: initialValues.beneficiaryName,
          alias: 'Beneficiary name',
          spec: spec.flow(string.isNotEmpty, any.required),
        },

        address1: {
          alias: 'address1',
          initialValue: initialValues.address?.address1,
          spec: spec.flow(string.isString),
        },
        address2: {
          alias: 'address2',
          initialValue: initialValues.address?.address2,
          spec: spec.flow(string.isString),
        },
        city: {
          alias: 'city',
          initialValue: initialValues.address?.city,
          spec: spec.flow(string.isString),
        },
        state: {
          alias: 'state',
          initialValue: initialValues.address?.state,
          spec: spec.flow(string.isString),
        },
        zip: {
          alias: 'zip',
          initialValue: initialValues.address?.zip,
          spec: spec.flow(string.isString),
        },
        country: {
          alias: 'country',
          initialValue: formattedCountry,
          spec: spec.flow(),
        },
      }
    }),
    withCallbacks({
      getOptionLabel:
        () =>
        ({ name }) =>
          name,
      getOptionValue:
        () =>
        ({ id }) =>
          id,

      loadJurisdictions:
        ({ jurisdictionsService }) =>
        (search = '') =>
          jurisdictionsService.getJurisdictionsPublic({ search }),
    }),
  ],
  transformProps: ({ appStore, ...rest }) => {
    return {
      ...rest,
      appConfig: appStore.appConfig,
    }
  },
})(BeneficiaryPersonalFormComponent)
